import React, { useEffect } from "react";
import { updateMildCasePackage } from "../../../../api/treatmentTypesApi";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { treatmentTypeSchema } from "../../schemas/treatmentTypesSchema";
const UpdateTreatmentTypeDialog = ({
  openUpdateTreatmentType,
  handleCloseUpdateTreatmentType,
  currentTreatmentType,
  fetchTreatmentTypes,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(treatmentTypeSchema),
  });
  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentTreatmentType.id;
    defaultValues.totalPayment = currentTreatmentType.totalPayment;
    defaultValues.name = currentTreatmentType.name;

    reset({ ...defaultValues });
  }, [currentTreatmentType, reset]);

  const submitUpdateTreatmentType = async (values) => {
    await updateMildCasePackage(values);
    handleCloseUpdateTreatmentType();
    fetchTreatmentTypes();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateTreatmentType}
        onClose={handleCloseUpdateTreatmentType}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Treatment Type</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateTreatmentType)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  name="name"
                  margin="dense"
                  variant="outlined"
                  label="Name"
                  id="package-name"
                  InputProps={{ inputProps: { step: "any" } }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  name="totalPayment"
                  margin="dense"
                  variant="outlined"
                  label="Total Payment"
                  type="number"
                  id="package-name"
                  InputProps={{ inputProps: { step: "any" } }}
                  error={errors.totalPayment}
                  helperText={errors.totalPayment?.message}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("totalPayment")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateTreatmentType}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateTreatmentTypeDialog;
